import { useEffect, useState } from "react";
import { FileText, Image as ImageIcon, Loader2 } from "lucide-react";
import clienteApi from "../../lib/clienteApi";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../../components/ui/dialog";

const isImg = (a) => (a.content_type || "").startsWith("image/");
const isPdf = (a) => (a.content_type || "") === "application/pdf" || /\.pdf$/i.test(a.nome || "");

export const AllegatoThumb = ({ pid, a, onOpen }) => {
  const [url, setUrl] = useState(null);
  useEffect(() => {
    if (!isImg(a)) return;
    clienteApi.get(`/cliente/pratiche/${pid}/allegati/${a.id}/thumb`).then(({ data }) => setUrl(data.url)).catch(() => {});
  }, [pid, a]);
  return (
    <button type="button" onClick={() => onOpen(a)} title="Apri anteprima" data-testid={`cliente-allegato-thumb-${a.id}`}
      className="h-12 w-12 shrink-0 overflow-hidden rounded-md border border-slate-200 bg-slate-50 flex items-center justify-center hover:ring-2 hover:ring-amber-400 transition-shadow">
      {url ? <img src={url} alt={a.nome} className="h-full w-full object-cover" />
        : isPdf(a) ? <span className="flex flex-col items-center text-red-600"><FileText className="h-5 w-5" /><span className="text-[9px] font-bold leading-none mt-0.5">PDF</span></span>
        : <ImageIcon className="h-5 w-5 text-slate-400" />}
    </button>
  );
};

export const AllegatoLightbox = ({ pid, item, onClose }) => {
  const [src, setSrc] = useState(null);
  const [err, setErr] = useState(false);
  useEffect(() => {
    if (!item) return undefined;
    setSrc(null); setErr(false);
    let url = null;
    clienteApi.get(`/cliente/pratiche/${pid}/allegati/${item.id}/content`, { responseType: "blob" })
      .then(({ data }) => { url = URL.createObjectURL(new Blob([data], { type: item.content_type || "application/octet-stream" })); setSrc(url); })
      .catch(() => setErr(true));
    return () => { if (url) URL.revokeObjectURL(url); };
  }, [pid, item]);
  return (
    <Dialog open={!!item} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-5xl w-[95vw]" data-testid="cliente-allegato-lightbox">
        <DialogHeader><DialogTitle className="truncate pr-6 text-base">{item?.nome}</DialogTitle></DialogHeader>
        <div className="flex items-center justify-center min-h-[50vh] max-h-[80vh] overflow-auto">
          {err ? <p className="text-sm text-red-600" data-testid="cliente-allegato-lightbox-error">Impossibile aprire il file.</p>
            : !src ? <Loader2 className="h-6 w-6 animate-spin text-amber-500" />
            : item && isImg(item) ? <img src={src} alt={item.nome} className="max-h-[78vh] max-w-full object-contain" data-testid="cliente-allegato-lightbox-img" />
            : <iframe src={src} title={item?.nome} className="w-full h-[78vh] rounded border border-slate-200" data-testid="cliente-allegato-lightbox-pdf" />}
        </div>
      </DialogContent>
    </Dialog>
  );
};
